import { SVG_COMPOSITE_CONSTANTS } from '@modules/Vector/S/Constant/composite.constant.ts';

// 모양스티커 테두리 옵션 (2mm, 3mm, 4mm)
export const OFFSET_BP_OPTION_GROUP = {
  bp_option_group_id: 463,
  bp_option: [
    {
      id: 1321,
      value: 2,
    },
    {
      id: 1322,
      value: 3,
    },
    {
      id: 1323,
      value: 4,
    },
  ],
};

export const MATERIAL_TYPE = {
  bp_option_group_id: 434,
  bp_option: [
    {
      id: 1380, // 크라프트
      source: '//s3.marpple.co/files/u_2798351/2025/8/original/2c53738f4bb356ed0607b660ba946d1acb5bfc121.png',
      type: 'multiply',
    },
    {
      id: 1382, // 아트지 유광
      source: '//s3.marpple.co/files/u_2798351/2025/8/original/27c0abdbc535b127b5f9f81315c3e7c8111d1a1b1.png',
      type: 'overlay',
    },
    {
      id: 1384, // 아트지 스파클링
      source: '//s3.marpple.co/files/u_2798351/2025/8/original/860be8c7f14168b6e80940195f3ab27b971ddc2d1.png',
      type: 'overlay',
    },
    {
      id: 1385, //  아트지 홀로그램
      source: '//s3.marpple.co/files/u_2798351/2025/9/original/2b175112ecc148c0d7d8ddbed423dcfdcdcb84181.png',
      type: 'multiply',
    },
  ],
};

export const MAX_DIMENSION = 90; // 초기 이미지 긴 변의 최대 길이
export const MIN_DIMENSION = 60; // 초기 이미지 긴 변의 최소 길이

export const GANGING_SAFETY_MARGIN_MM = 4; // 조판 제한 대비 안전마진 (프론트에서 이 만큼 더 min / max 범위가 좁게 제한 됨)
export const MAX_LONG_SIDE_WITH_OFFSET_MM = 174; // 조판 최대 크기의 긴 변 (Front 에서 유저는 GANGING_SAFETY_MARGIN_MM 만큼 더 작은 값까지 제어 가능)
export const MAX_SHORT_SIDE_WITH_OFFSET_MM = 128; // 조판 최대 크기의 짧은 변 (Front 에서 유저는 GANGING_SAFETY_MARGIN_MM 만큼 더 작은 값까지 제어 가능)
export const MIN_SHORT_SIDE_WITH_OFFSET_MM = 26; // 조판 최소 크기의 짧은 변 (Front 에서 유저는 GANGING_SAFETY_MARGIN_MM 만큼 더 큰 값까지 제어 가능)

export const GANGING_MAX_DIMENSION_MM = 174; // 조판시 실제 허용되는 최대 길이
export const GANGING_MIN_DIMENSION_MM = 25; // 조판시 실제 허용되는 최소 길이

export const INITIAL_SIZE_RANGE = {
  min_width: 30,
  max_width: 90,
  min_height: 174,
  max_height: 128,
};

export const PLUSH_PRODUCT = {
  ID: 8857,
  OFFSET: 20,
  MATERIAL_SOURCE: {
    type: SVG_COMPOSITE_CONSTANTS.MATERIAL_TYPES.MULTIPLY,
    source: '//s3.marpple.co/files/u_2798351/2025/10/original/ce744f309d66f7db4b51bb7080b802ebf6af33221.png',
  },
};

export const JOGAK_STIKER_PRODUCT = {
  ID: 8213,
};
